<template>
  <div 
    id="OrdersSearchWidgetForm"
    class="left-menu"
  >
    <div class="nav-sub p-0">
      <h4>{{ getContentItem("search") }}</h4>
      <div class="claimsOrdersSearchBody">
        <form @submit.prevent="search">
          <b-form-group
            :label="getContentItem('searchByMessage')"
            label-for="documentNumberSearchTerm"
          >
            <b-form-input
              id="documentNumberSearchTerm"
              v-model="documentNumberSearchTerm"
              size="sm"
            />
          </b-form-group>

          <b-form-group :label="getContentItem('searchByPart')" label-for="partNumberSearchTerm">
            <b-form-input id="partNumberSearchTerm" v-model="partNumberSearchTerm" size="sm" />
          </b-form-group>

          <AvailableDealerCodeSelector
            :show-all-branches-option="hasAccessToAllBranches"
            class="vSelectDropDownText claimsDealerCodeSearch-noWrap"
            :default-dealercode="defaultDealerCode"
            @selectDealerCode="SetUserDealerCode"
          />

          <div class="text-right">
            <input 
              type="submit" 
              class="btn btn-inverse mt-2" 
              :class="{'default-cursor': (documentNumberSearchTerm === '' && partNumberSearchTerm === '')}"
              :disabled="(documentNumberSearchTerm === '' && partNumberSearchTerm === '')"
              :value="getContentItem('goButton')"
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters }              from "vuex"
  import AvailableDealerCodeSelector from "@/components/Dropdowns/AvailableDealerCodeSelector"

  export default {
    components: {
      AvailableDealerCodeSelector,
    },
    props: {
      documentNumber: {
        type: String,
        default: "",
      },
      partNumber: {
        type: String,
        default: "",
      },
      dealerCode: {
        type: String,
        default: "",
      },
      dealerFilter: {
        type: Array,
        default: () => [],
      }
    },
    data: function() {
      return {
        documentNumberSearchTerm: this.documentNumber,
        partNumberSearchTerm: this.partNumber,
        dealerCodeFilter: this.dealerCode,
        dealerCodes: this.dealerFilter,
      }
    },
    computed: {
      ...mapGetters(["getContentItem", "user","availableDealerCodes"]),
      hasAccessToAllBranches() {
        return (
          this.availableDealerCodes.length > 1 && this.user.DealerRange !== "*"
        );
      },
      defaultDealerCode(){
        return this.dealerCodeFilter === "All" ? null : this.dealerCodeFilter;
      }
    },
    created() {
      if (!this.dealerCodeFilter) {
        if(!this.hasAccessToAllBranches){
          this.dealerCodeFilter = this.user.DealerCode;
        }
        else{
          this.dealerCodeFilter = "ALL";
        } 
      }
    },
    methods: {
      SetUserDealerCode(selectedDealer) {
        if (selectedDealer.PrimaryDealerCode) {
          this.dealerCodeFilter = selectedDealer.PrimaryDealerCode
        } else if (selectedDealer.value === "All Branches") {
          this.dealerCodeFilter = "ALL";
        }
      },
      search() {
        // Build dealerFilter array based on selected dealer code
        let dealerFilterArray = [];
        if (this.dealerCodeFilter !== "ALL") {
          dealerFilterArray = [this.dealerCodeFilter];
        }
        
        this.$router.push({
          name: "OrderSearch",
          query: {
            documentNumber: this.documentNumberSearchTerm.trim(),
            partNumber: this.partNumberSearchTerm.trim(),
            dealerCode: this.dealerCodeFilter.toString(),
            dealerFilter: dealerFilterArray,
          },
        }).catch(error => {
          if(error.name != "NavigationDuplicated") {
            throw error;
          }
        })
      },
    },
  }
</script>
<style lang="scss">
  .default-cursor{
    cursor: default;
  }

</style>